import { render, staticRenderFns } from "./OnlineTraining.vue?vue&type=template&id=b89f64a2&scoped=true&"
import script from "./OnlineTraining.vue?vue&type=script&lang=js&"
export * from "./OnlineTraining.vue?vue&type=script&lang=js&"
import style0 from "./OnlineTraining.vue?vue&type=style&index=0&id=b89f64a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89f64a2",
  null
  
)

export default component.exports